import React, { useState } from 'react'
import { SchContentContainer, SchMenus } from '../../shared/molecules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import Wrapper from './style'
import { JSONmenus } from '../../../assets/JSON'
import SchChildMenu from '../../shared/molecules/SchMenus/SchChildMenu'
import { SchButton } from '../../shared/atoms'
import { traitItems } from '../../utils'

const TraitChecker = () => {
	const [menuActive, setMenuActive] = useState({
		"background": 0,
		"base": 0,
		"eyes": 0,
		"outfit": 0,
		"mouth": 0,
		"headgear": 0,
	});

	const onClickMenu = (key, value) => {
		setMenuActive({
			...menuActive,
				[key]: value
		})
	}

	const onClear = () => {
		setMenuActive({
			"background": 0,
			"base": 0,
			"eyes": 0,
			"outfit": 0,
			"mouth": 0,
			"headgear": 0,
		})
	}

	const onClearOne = (key) => {
		setMenuActive({
			...menuActive,
			[key]: 0
		})
	}

	const fill = menuActive.background !== 0 | menuActive.base !== 0 | menuActive.eyes !== 0 | menuActive.outfit !== 0  | menuActive.mouth !== 0 | menuActive.headgear !== 0 ;

	return (
		<SchContentContainer>
			<Wrapper>
				<div className="left-wrapper">
					{traitItems.map(item => {
						return (
							<SchMenus
								key={item}
								value={item}
								amount={(() => {
									switch (item) {
										case "background":
											return JSONmenus.menus.background.length
										case "base":
											return JSONmenus.menus.base.length
										case "eyes":
											return JSONmenus.menus.eyes.length
										case "outfit":
											return JSONmenus.menus.outfit.length
										case "mouth":
											return JSONmenus.menus.mouth.length
										case "headgear":
											return JSONmenus.menus.headgear.length
										default:
											break;
									}
								})()}
								iconOnLeft={(() => {
									switch (item) {
										case "base":
											return <img src={`./assets/artwork/icon/base.svg`} alt={`${item}-scholarz`}/>
										case "eyes":
											return <img src={`./assets/artwork/icon/eyes.svg`} alt={`${item}-scholarz`}/>
										case "outfit":
											return <img src={`./assets/artwork/icon/outfit.svg`} alt={`${item}-scholarz`}/>
										case "mouth":
											return <img src={`./assets/artwork/icon/mouth.svg`} alt={`${item}-scholarz`}/>
										case "headgear":
											return <img src={`./assets/artwork/icon/headgear.svg`} alt={`${item}-scholarz`}/>
										default:
											break;
									}
								})()}
								iconOnRight={(
									<FontAwesomeIcon
										icon={faChevronDown}
										fixedWidth
									/>
								)}
								children={(() => {
											switch (item) {
												case "background":
													return JSONmenus.menus.background.map(menu => {
														return (
															<SchChildMenu
																key={menu}
																active={menu === menuActive.background}
																onClick={() => onClickMenu("background", menu)}
															>
																background {menu}
															</SchChildMenu>
														)
													})
												case "base":
													return JSONmenus.menus.base.map(menu => {
														return (
															<SchChildMenu
																key={menu}
																active={menu === menuActive.base}
																onClick={() => onClickMenu("base", menu)}
															>
																Base {menu}
															</SchChildMenu>
														)
													})
												case "eyes":
													return JSONmenus.menus.eyes.map(menu => {
														return (
															<SchChildMenu
																key={menu}
																active={menu === menuActive.eyes}
																onClick={() => onClickMenu("eyes", menu)}
															>
																Eyes {menu}
															</SchChildMenu>
														)
													})
												case "outfit":
													return JSONmenus.menus.outfit.map(menu => {
														return (
															<SchChildMenu
																key={menu}
																active={menu === menuActive.outfit}
																onClick={() => onClickMenu("outfit", menu)}
															>
																Outfit {menu}
															</SchChildMenu>
														)
													})
												case "mouth":
													return JSONmenus.menus.mouth.map(menu => {
														return (
															<SchChildMenu
																key={menu}
																active={menu === menuActive.mouth}
																onClick={() => onClickMenu("mouth", menu)}
															>
																Mouth {menu}
															</SchChildMenu>
														)
													})
												case "headgear":
													return JSONmenus.menus.headgear.map(menu => {
														return (
															<SchChildMenu
																key={menu}
																active={menu === menuActive.headgear}
																onClick={() => onClickMenu("headgear", menu)}
															>
																Headgear {menu}
															</SchChildMenu>
														)
													})
												default:
													break;
											}
										})()
								}
							/>
						)
					})}
				</div>
				<div className="right-wrapper">
					<div className="content-wrapper">
						<div className="img-container">
							{menuActive.background !== 0
								&& <img
										src={`./assets/traits/background/${menuActive.background}.png`}
										alt={`background${menuActive.background}`}
										className="background"
									/>
							}
							{menuActive.base !== 0
								&& <img
										src={`./assets/traits/base/${menuActive.base}.png`}
										alt={`base${menuActive.base}`}
										className="base"
									/>
							}
							{menuActive.eyes !== 0
								&& <img
										src={`./assets/traits/eyes/${menuActive.eyes}.png`}
										alt={`eyes${menuActive.eyes}`}
										className="eyes"
									/>
							}
							{menuActive.outfit !== 0
								&& <img
										src={`./assets/traits/outfit/${menuActive.outfit}.png`}
										alt={`outfit${menuActive.outfit}`}
										className="outfit"
									/>
							}
							{menuActive.mouth !== 0
								&& <img
										src={`./assets/traits/mouth/${menuActive.mouth}.png`}
										alt={`mouth${menuActive.mouth}`}
										className="mouth"
									/>
							}
							{menuActive.headgear !== 0
								&& <img
										src={`./assets/traits/headgear/${menuActive.headgear}.png`}
										alt={`headgear${menuActive.headgear}`}
										className="headgear"
									/>
							}
						</div>
						{
							fill
								?
									<div className="user-selection">
										{menuActive.background !== 0
											&& <div
													className="selection"
													onClick={() => onClearOne("background")}
												>
													{`Background ${menuActive.background}`}
													<FontAwesomeIcon
														icon={faCircleXmark}
														fixedWidth
													/>
												</div>
										}
										{menuActive.base !== 0
											&& <div
													className="selection"
													onClick={() => onClearOne("base")}
												>
													{`Base ${menuActive.base}`}
													<FontAwesomeIcon
														icon={faCircleXmark}
														fixedWidth
													/>
												</div>
										}
										{menuActive.eyes !== 0
											&& <div
													className="selection"
													onClick={() => onClearOne("eyes")}
												>
													{`Eyes ${menuActive.eyes}`}
													<FontAwesomeIcon
														icon={faCircleXmark}
														fixedWidth
													/>
												</div>
										}
										{menuActive.outfit !== 0
											&& <div
													className="selection"
													onClick={() => onClearOne("outfit")}
												>
													{`Outfit ${menuActive.outfit}`}
													<FontAwesomeIcon
														icon={faCircleXmark}
														fixedWidth
													/>
												</div>
										}
										{menuActive.mouth !== 0
											&& <div
													className="selection"
													onClick={() => onClearOne("mouth")}
												>
													{`Mouth ${menuActive.mouth}`}
													<FontAwesomeIcon
														icon={faCircleXmark}
														fixedWidth
													/>
												</div>
										}
										{menuActive.headgear !== 0
											&& <div
													className="selection"
													onClick={() => onClearOne("headgear")}
												>
													{`Headgear ${menuActive.headgear}`}
													<FontAwesomeIcon
														icon={faCircleXmark}
														fixedWidth
													/>
												</div>
										}
									</div>
								: <></>
						}
						<div className="button-container">
							<SchButton
								onClick={onClear}
								disabled={!fill}
							>
								Clear All
							</SchButton>
							<SchButton
								onClick={() => alert('Check')}
								type="success"
							>
								Check
							</SchButton>
						</div>
					</div>

				</div>
			</Wrapper>
		</SchContentContainer>
	)
}

export default TraitChecker
